import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Spin, Row, Select, Button, DatePicker, Input } from 'antd';
import moment from "moment"
import './index.scss';
import Potential from './Potential';
import Recommend from './Recommend';
import { runInAction } from 'mobx';
const { Option } = Select;

@inject('store')
@observer
class App extends Component {
    state = {
        dateData: [],
    }

    componentDidMount() {
        let date = Number(this.props.store.salesPersonnel.date || "0");
        let dateData = [];
        let len = date - 2018 + 3;
        for (let i = 0; i < len; i++) {
            dateData.push((2018 + i).toString())
        }
        this.setState({ dateData });
        this.props.store.salesPersonnel.getData(this.props.store.salesPersonnel.date);
    }

    render() {
        const { loading, date, getData, onSave, saving, notes } = this.props.store.salesPersonnel;
        return (
            <Spin spinning={loading}>
                <div className="table7_1_1 salesPersonnel">
                    <Row className="title" id="table11">
                        <Row>销售部人员评估</Row>
                        <Row className="table-month">
                            <Select
                                placeholder="请选择年份"
                                style={{ width: 120 }}
                                value={date}
                                onChange={str => {
                                    runInAction(() => {
                                        this.props.store.salesPersonnel.date = str;
                                    });
                                    getData(str);
                                }}
                            >
                                {this.state.dateData.map((x, i) => {
                                    return (
                                        <Option key={x}>{x}年</Option>
                                    )
                                })}
                            </Select>
                            <span className="note">注：此表每年2月1日-3月10日期间填写。</span>
                        </Row>
                        <Potential />
                        <Recommend />
                        <Button
                            className="footer-btn"
                            type="primary"
                            onClick={onSave}
                            loading={saving}
                        >
                            保存
                        </Button>

                    </Row>
                </div>
            </Spin>

        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/salesPersonnelAssessment/index.js